import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { ServiceData } from "../../data/service/ServiceData.js";
import { useLanguage } from '../../context/LanguageContext.js';
import { Features } from '../../assets/features/Features.js';


const ServicePropOne = ({colSize, serviceStyle, itemShow, marginTop}) => {
	const { language } = useLanguage();
	const AllData = ServiceData[language];

	const topMargin = (index) => {
		if (marginTop === "yes") {
			if (index === 0) {
				return "mt--200 mt_md--0";
			} else if (index === 1) {
				return "mt--100 mt_md--0";
			}else {
				return "mt--0";
			}
		}else {
			return "";
		}
	}

	const ServiceCard = ({data, index}) => {
		const [isModalOpen, setIsModalOpen] = useState(false);
		const maxLength = 200;
		// Always truncate text to allow viewing full text in modal
		const truncatedText = data.description.length > maxLength 
			? data.description.substring(0, maxLength) + '...' 
			: data.description;

		const openModal = () => {
			setIsModalOpen(true);
			// Prevent body scroll
			document.body.style.overflow = 'hidden';
		};
		
		const closeModal = () => {
			setIsModalOpen(false);
			// Restore body scroll
			document.body.style.overflow = 'unset';
		};

		// Close modal on escape key and cleanup on unmount
		React.useEffect(() => {
			const handleEscape = (e) => {
				if (e.key === 'Escape' && isModalOpen) {
					closeModal();
				}
			};
			
			if (isModalOpen) {
			document.addEventListener('keydown', handleEscape);
			}
			
			// Cleanup function
			return () => {
				document.removeEventListener('keydown', handleEscape);
				// Ensure scroll is restored if component unmounts while modal is open
				if (isModalOpen) {
					document.body.style.overflow = 'unset';
				}
			};
		}, [isModalOpen]);

		return (
			<>
				<div className={`${colSize} ${topMargin(index)}`} key={index}>
					<div className={`services-grid ${serviceStyle}`}>
						<div className="thumbnail">
							<img src={process.env.PUBLIC_URL + data.image} alt="icon" />
						</div>
						<div className="content">
							<h5 className="title"> 
								{data.title}
							</h5>
							<div className="description-wrapper">
								<p className="description-text">
									{truncatedText}
								</p>
								<button 
									className="read-more-btn" 
									onClick={openModal}
								>
									{Features.COMMON.SEE_MORE[language]}
								</button>
							</div>
						</div>
						<style jsx>{`
							.description-wrapper {
								position: relative;
							}
							.description-text {
								line-height: 1.6;
								margin-bottom: 0;
							}
							.read-more-btn {
								margin-top: 20px;
								padding: 10px 25px;
								background: var(--color-primary);
								color: #fff;
								border: none;
								border-radius: 5px;
								cursor: pointer;
								font-size: 14px;
								font-weight: 500;
								transition: all 0.3s ease;
								display: inline-block;
							}
							.read-more-btn:hover {
								background: var(--color-secondary);
								transform: translateY(-2px);
								box-shadow: 0 4px 12px rgba(0,0,0,0.15);
							}
							.read-more-btn:active {
								transform: translateY(0);
							}
						`}</style>
					</div>
				</div>

				{/* Modal Dialog - Rendered using Portal */}
				{isModalOpen && ReactDOM.createPortal(
					<div className="service-modal-overlay" onClick={closeModal}>
						<div className="service-modal-content" onClick={(e) => e.stopPropagation()}>
							<button className="service-modal-close" onClick={closeModal} aria-label={Features.COMMON.CLOSE[language]}>
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
									<line x1="18" y1="6" x2="6" y2="18"></line>
									<line x1="6" y1="6" x2="18" y2="18"></line>
								</svg>
							</button>
							<div className="service-modal-header">
								<div className="service-modal-icon">
									<img src={process.env.PUBLIC_URL + data.image} alt="icon" />
								</div>
								<h3 className="service-modal-title">{data.title}</h3>
							</div>
							<div className="service-modal-body">
								<p className="service-modal-description">{data.description}</p>
							</div>
						</div>
						<style jsx>{`
							.service-modal-overlay {
								position: fixed;
								top: 0;
								left: 0;
								right: 0;
								bottom: 0;
								background: rgba(0, 0, 0, 0.7);
								backdrop-filter: blur(5px);
								display: flex;
								align-items: center;
								justify-content: center;
								z-index: 999999;
								padding: 20px;
								animation: fadeIn 0.3s ease;
								overflow-y: auto;
							}
							@keyframes fadeIn {
								from {
									opacity: 0;
								}
								to {
									opacity: 1;
								}
							}
						.service-modal-content {
							background: var(--color-white);
							border-radius: 12px;
							max-width: 700px;
							width: 100%;
							max-height: 90vh;
							overflow-y: auto;
							position: relative;
							box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
							animation: slideUp 0.3s ease;
						}
							@keyframes slideUp {
								from {
									transform: translateY(30px);
									opacity: 0;
								}
								to {
									transform: translateY(0);
									opacity: 1;
								}
							}
							.service-modal-close {
								position: absolute;
								top: 20px;
								right: 20px;
								background: transparent;
								border: none;
								cursor: pointer;
								padding: 8px;
								border-radius: 50%;
								display: flex;
								align-items: center;
								justify-content: center;
								transition: all 0.3s ease;
								color: var(--color-dark);
								z-index: 10;
							}
							.service-modal-close:hover {
								background: rgba(0, 0, 0, 0.1);
								transform: rotate(90deg);
							}
							.service-modal-header {
								padding: 40px 40px 20px;
								text-align: center;
								border-bottom: 1px solid rgba(0, 0, 0, 0.1);
							}
							.service-modal-icon {
								margin-bottom: 20px;
							}
							.service-modal-icon img {
								width: 80px;
								height: 80px;
								object-fit: contain;
							}
							.service-modal-title {
								font-size: 28px;
								font-weight: 700;
								color: var(--color-dark);
								margin: 0;
								line-height: 1.3;
							}
							.service-modal-body {
								padding: 30px 40px 40px;
							}
							.service-modal-description {
								font-size: 16px;
								line-height: 1.8;
								color: var(--color-body);
								margin: 0;
								white-space: pre-line;
							}
							@media (max-width: 768px) {
								.service-modal-content {
									max-width: 95%;
									max-height: 95vh;
								}
								.service-modal-header {
									padding: 30px 20px 15px;
								}
								.service-modal-body {
									padding: 20px;
								}
								.service-modal-title {
									font-size: 22px;
								}
							.service-modal-close {
								top: 15px;
								right: 15px;
							}
						}
						:global(body.active-dark-mode .service-modal-content) {
							background: var(--color-dark);
						}
						:global(body.active-dark-mode .service-modal-close) {
							color: var(--color-white);
						}
						:global(body.active-dark-mode .service-modal-close:hover) {
							background: rgba(255, 255, 255, 0.1);
						}
						:global(body.active-dark-mode .service-modal-title) {
							color: var(--color-white);
						}
						:global(body.active-dark-mode .service-modal-description) {
							color: var(--color-body);
						}
						:global(body.active-dark-mode .service-modal-header) {
							border-bottom-color: rgba(255, 255, 255, 0.1);
						}
					`}</style>
					</div>,
					document.body
				)}
			</>
		);
	};

    return (
		<>
			{AllData.slice(0, itemShow).map((data, index) => (
				<ServiceCard data={data} index={index} key={index} />
			))}
		</>
    )
}

export default ServicePropOne;